<template>
	<div tabindex="0" class="hide-outline">
		<main class="main-view no-top-panel">
			<div class="title">Starta rond</div>
			<div class="top-box">
				<div class="row" :style="mobile">
					<div class="field name">
						<label class="label">Namn</label>
						<div class="control">
							<textarea
								v-model="roundHistory.name"
								class="textarea no-resize"
								rows="2"
								placeholder="Rondens namn"
								disabled
							/>
						</div>
					</div>
					<div class="field description">
						<label class="label">Beskrivning</label>
						<div class="control">
							<textarea
								v-model="roundHistory.description"
								class="textarea no-resize"
								rows="2"
								placeholder="Rondens beskrivning"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="row" :style="mobile">
					<div class="field name">
						<label class="label">Ansvarig</label>
						<div class="control">
							<input
								v-model="roundHistory.roleName"
								class="input"
								placeholder="Ansvarig för ronden"
								disabled
							/>
						</div>
					</div>
					<div class="field name">
						<label class="label">Kontrollpunkter</label>
						<div class="control">
							<input
								v-model="items"
								class="input"
								placeholder="Antal kontrollpunkter"
								disabled
							/>
						</div>
					</div>
					<div class="field name">
						<label class="label">Frågor</label>
						<div class="control">
							<input
								v-model="lists"
								class="input"
								placeholder="Antal kontrollpunkter"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="row" :style="mobile">
					<div class="field name">
						<label class="label">Utförare</label>
						<div class="control">
							<input
								v-model="getUser.email"
								class="input"
								placeholder="Utförare för ronden"
								disabled
							/>
						</div>
					</div>
					<div class="field name">
						<label class="label">Status</label>
						<div class="control">
							<input
								v-model="status"
								class="input"
								placeholder="Status"
								disabled
							/>
						</div>
					</div>
					<div class="buttons">
						<button
							class="button is-info"
							@click="startRound"
							:class="{ 'is-loading': !ready }"
						>
							<span
								class="icon is-white"
							><i v-if="ready" class="fas fa-play"/></span
							><span>Starta</span></button
						><button class="button is-dark" @click="cancel" v-if="!isMobile">
							<span class="icon"><i class="fas fa-backward"/></span>
							<span>Tillbaka</span>
						</button>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
export default {
	data: () => ({
		questionsDone: false,
		itemsDone: false
	}),
	computed: {
		...mapGetters('roundHistoryStore', ['roundHistory']),
		...mapGetters('roundHistoryQuestionStore', ['roundHistoryQuestionLists']),
		...mapState('roundHistoryQuestionStore', {
			questionParams: 'searchParams'
		}),
		...mapGetters('roundHistoryInfoStore', ['roundHistoryInfos']),
		...mapState('roundHistoryInfoStore', {
			infoParams: 'searchParams'
		}),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('user', ['getUser']),
		mobile() {
			return this.isMobile ? { display: 'block' } : '';
		},
		items() {
			let items = 0;

			if (this.roundHistoryInfos) {
				this.roundHistoryInfos.forEach(info => {
					items += info.roundHistoryItems.length;
				});
			}

			return items;
		},
		lists() {
			let questions = 0;

			if (this.roundHistoryQuestionLists) {
				this.roundHistoryQuestionLists.forEach(questionList => {
					questions += questionList.roundHistoryQuestions.length;
				});
			}

			return questions;
		},
		status() {
			return this.roundHistory.updated > this.roundHistory.created
				? `Påbörjad (Uppdaterad: ${this.moment(
					this.roundHistory.updated
				).format('YYYY-MM-DD')})`
				: 'Väntar';
		},
		ready() {
			return this.questionsDone && this.itemsDone;
		}
	},
	methods: {
		...mapActions('roundHistoryStore', [
			'getRoundHistory',
			'getActiveRoundHistoryByPlanningId'
		]),
		...mapActions('roundHistoryQuestionStore', [
			'getRoundHistoryQuestionLists'
		]),
		...mapActions('roundHistoryInfoStore', ['getRoundHistoryInfos']),
		...mapMutations('roundHistoryStore', ['SET_ACTIVEROUND']),
		startRound() {
			let round = this.roundHistory;

			let infoList = [];
			this.roundHistoryInfos.forEach(info => {
				info.roundHistoryItems.sort((a, b) =>
					a.positionNumber > b.positionNumber
						? 1
						: a.positionNumber === b.positionNumber
							? 0
							: -1
				);
				infoList.push(info);
			});
			round.infos = infoList;
			round.oldInfos = infoList;

			round.checklists = this.roundHistoryQuestionLists;
			round.oldChecklists = this.roundHistoryQuestionLists;
			round.userName = this.getUser.email;
			this.SET_ACTIVEROUND(round);
			this.$router.push({
				name: 'RoundView',
				params: { roundId: round.id }
			});
		},
		cancel() {
			this.$router.push('/');
		}
	},

	created() {
		const roundId = this.$route.params.roundId;
		this.getActiveRoundHistoryByPlanningId(roundId).then(() => {
			this.questionParams.pageSize = 0;
			this.infoParams.pageSize = 0;
			this.questionParams.roundHistoryId = this.roundHistory.id;
			this.infoParams.roundHistoryId = this.roundHistory.id;

			this.getRoundHistoryQuestionLists().then(() => {
				this.questionsDone = true;
			});

			this.getRoundHistoryInfos().then(() => {
				this.itemsDone = true;
			});
		});
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;
  .row {
    display: flex;
  }
  .field {
    &.name {
      flex: 1;
    }
    &.description {
      flex: 2;
    }
    margin-left: 10px;
    margin-right: 10px;
    .label {
      font-size: 12px;
    }
  }
  .textarea,
  .input {
    background: white;
    border-radius: 2px;
  }
  .buttons {
    margin: 0;
    margin-top: 19px;
    margin-left: 10px;
    .button {
      border-radius: 2px;
      width: 110px;
    }
  }
}
</style>
